export const socialLinks = [
  {
    name: 'GitHub',
    href: 'https://github.com/mtz-juncogerardo',
    icon: 'github'
  },
  {
    name: 'LinkedIn',
    href: 'https://linkedin.com/in/gerardo-mart%C3%ADnez-junco-174315377',
    icon: 'linkedin'
  },
  {
    name: 'Dev Journal',
    href: '/diario',
    icon: 'BookOpen',
    i18nKey: 'about.status.journal',
    internal: true
  }
];
